import React, { useState } from "react";
import {
  Button,
  Input,
  Col,
  Label,
  Container,
  Row,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  ListGroup,
  ListGroupItem,
  Card,
  CardBody,
  CardHeader,
} from "reactstrap";

import { Link } from "react-router-dom";
import classnames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import Website from "./Knowledge_Tab_content/Website";
import QuestionAnswer from "./Knowledge_Tab_content/QuestionAnswer";
import File_Upload from "./Knowledge_Tab_content/File";
import Text from "./Knowledge_Tab_content/Text";
import Db_Link from "./Knowledge_Tab_content/Db_Link";
import { useEffect } from "react";
import Not_Available_With_Current_Plan from "../Not Available/Not_Available_With_Current_Plan";
import SharePoint from "./SharePoint";
import config from "../../config";
import { GET_DB_Connection_for_bot_config, GET_TABLE_DETAILS } from "../../slices/thunks";





const Knowledge = () => {
  const dispatch = useDispatch()
  const { Type , Database_ID , Bot_ID } = useSelector((state) => state.BotDetails.Bot_Details);
  const { plan_features_available } = useSelector((state) => state.Plans)
  const [verticalTab, setverticalTab] = useState("1");
  const toggleVertical = (tab) => {
    if (verticalTab !== tab) {
      setverticalTab(tab);
    }
  };


  useEffect(()=>{
    if(Type === 'General')
    {
      setverticalTab('1')
    }else{
      setverticalTab('5')
    }

  },[])

  useEffect(() => {
    // DB-dependent data
     if (Database_ID) {
       dispatch(
         GET_DB_Connection_for_bot_config({ database_id: Database_ID })
       );
       dispatch(
         GET_TABLE_DETAILS({
           databaseId: Database_ID,
           page_size: config.general_config.PER_PAGE_CONTENT,
           page: 1,
           search_term: "",
           Bot_ID: Bot_ID,
         })
       );
     }
  }, [Database_ID])
  


  const check_for_allowed_feature = ({ feature_name })=>{
        let decision = false
       plan_features_available.forEach(element => {
           
        if(element.Bot_type.toLowerCase() == feature_name.toLowerCase() && element.Allowed_To_User){
          decision= true
        }

       });

       return decision
  }

  return (
    <Row>
      <Col md={2}>
        <Nav pills className="flex-column" id="v-pills-tab">

         { Type === 'General' ? <>
          <NavItem>
            <NavLink
              style={{ cursor: "pointer" }}
              className={classnames({
                "mb-2": true,
                active: verticalTab === "1",
              })}
              onClick={() => {
                toggleVertical("1");
              }}
              id="v-pills-home-tab"
            >
              <i className=" ri-file-line"></i> Files
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              style={{ cursor: "pointer" }}
              className={classnames({
                "mb-2": true,
                active: verticalTab === "2",
              })}
              onClick={() => {
                toggleVertical("2");
              }}
              id="v-pills-profile-tab"
            >
              <i className="ri-align-left"></i> Text
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              style={{ cursor: "pointer" }}
              className={classnames({
                "mb-2": true,
                active: verticalTab === "3",
              })}
              onClick={() => {
                toggleVertical("3");
              }}
              id="v-pills-website-tab"
            >
              <i className="ri-global-line"></i> Website
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              style={{ cursor: "pointer" }}
              className={classnames({
                active: verticalTab === "4",
              })}
              onClick={() => {
                toggleVertical("4");
              }}
              id="v-pills-settings-tab"
            >
              <i className="ri-database-line"></i> Q&A
            </NavLink>
          </NavItem>
           <NavItem>
            <NavLink
              style={{ cursor: "pointer" }}
              className={classnames({
                active: verticalTab === "6",
              })}
              onClick={() => {
                toggleVertical("6");
              }}
              id="v-pills-settings-tab"
            >
              <i className="ri-database-line"></i> Share point
            </NavLink>
          </NavItem>
         
          </>
           
           :     
           <>
        <NavItem>
            <NavLink
              style={{ cursor: "pointer" }}
              className={classnames({
                active: verticalTab === "5",
              })}
              onClick={() => {
                toggleVertical("5");
              }}
              id="v-pills-settings-tab"
            >
              <i className="ri-question-answer-line"></i> DB Link
            </NavLink>
          </NavItem>
        
          </>
}

          
        </Nav>
      </Col>
      <Col md={10}>
        <TabContent
          activeTab={verticalTab}
          className="text-muted mt-4 mt-md-0"
          id="v-pills-tabContent"
        >
        { 
        Type === 'General' ?
         <>
         <TabPane tabId="1" id="v-pills-home">
            { check_for_allowed_feature({feature_name:'Upload File'}) ? <File_Upload />: <Not_Available_With_Current_Plan/> }
          </TabPane><TabPane tabId="2" id="v-pills-profile">
              {check_for_allowed_feature({feature_name:'Text'}) ? <Text />: <Not_Available_With_Current_Plan/>}
            </TabPane><TabPane tabId="3" id="v-pills-website">
              {check_for_allowed_feature({feature_name:'Website'}) ? <Website />: <Not_Available_With_Current_Plan/>}
            </TabPane><TabPane tabId="4" id="v-pills-settings">
              {check_for_allowed_feature({feature_name:'Upload Q&A'}) ? <QuestionAnswer />: <Not_Available_With_Current_Plan/>}
            </TabPane><TabPane tabId="6" id="v-pills-sharepoint">
             { verticalTab =='6' && <SharePoint />}
            </TabPane>
            </>
            :
          <TabPane tabId="5" id="v-pills-settings">
           { check_for_allowed_feature({feature_name:'DbLink'}) ?  <Db_Link /> : <Not_Available_With_Current_Plan/>}
          </TabPane>
}
        </TabContent>
      </Col>
    </Row>
  );
};

export default Knowledge;
